module.exports = __webpack_public_path__ + "assets/events_disasters_black.7646ce6b.svg";